import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const HomeSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default HomeSVG;
